/**
 * @generated SignedSource<<77284df55a815046702c2be941c20972>>
 * @relayHash 69fa53a2c8dab0673f36de450960156d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bacee27ce08e8cbeca32c8698c834298f4e6536c5ce14e4f68ba78590d602fdb

import type { ConcreteRequest, Query } from 'relay-runtime';
export type getIssueTypeProps_initialOptionsQuery$variables = {
  cloudId: string;
  jql: string;
};
export type getIssueTypeProps_initialOptionsQuery$data = {
  readonly jira: {
    readonly jqlBuilder: {
      readonly issueTypes: {
        readonly aboveBaseLevel: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly displayName: string;
              readonly issueTypes: ReadonlyArray<{
                readonly avatar: {
                  readonly xsmall: string | null | undefined;
                } | null | undefined;
              }>;
              readonly jqlTerm: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly baseLevel: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly displayName: string;
              readonly issueTypes: ReadonlyArray<{
                readonly avatar: {
                  readonly xsmall: string | null | undefined;
                } | null | undefined;
              }>;
              readonly jqlTerm: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly belowBaseLevel: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly displayName: string;
              readonly issueTypes: ReadonlyArray<{
                readonly avatar: {
                  readonly xsmall: string | null | undefined;
                } | null | undefined;
              }>;
              readonly jqlTerm: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  };
};
export type getIssueTypeProps_initialOptionsQuery = {
  response: getIssueTypeProps_initialOptionsQuery$data;
  variables: getIssueTypeProps_initialOptionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "jql"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "jqlContext",
    "variableName": "jql"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v5 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v6 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v7 = [
  {
    "concreteType": "JiraJqlIssueTypeFieldValueEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraJqlIssueTypeFieldValue",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "issueTypes",
            "plural": true,
            "selections": [
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  }
],
v8 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  }
],
v9 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
],
v10 = [
  {
    "concreteType": "JiraJqlIssueTypeFieldValueEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraJqlIssueTypeFieldValue",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "issueTypes",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "getIssueTypeProps_initialOptionsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v1/*: any*/),
              "concreteType": "JiraJqlBuilder",
              "kind": "LinkedField",
              "name": "jqlBuilder",
              "plural": false,
              "selections": [
                {
                  "args": (v2/*: any*/),
                  "concreteType": "JiraJqlIssueTypes",
                  "kind": "LinkedField",
                  "name": "issueTypes",
                  "plural": false,
                  "selections": [
                    {
                      "args": (v3/*: any*/),
                      "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                      "kind": "LinkedField",
                      "name": "aboveBaseLevel",
                      "plural": false,
                      "selections": (v7/*: any*/),
                      "storageKey": "aboveBaseLevel(first:2)"
                    },
                    {
                      "args": (v8/*: any*/),
                      "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                      "kind": "LinkedField",
                      "name": "baseLevel",
                      "plural": false,
                      "selections": (v7/*: any*/),
                      "storageKey": "baseLevel(first:3)"
                    },
                    {
                      "args": (v9/*: any*/),
                      "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                      "kind": "LinkedField",
                      "name": "belowBaseLevel",
                      "plural": false,
                      "selections": (v7/*: any*/),
                      "storageKey": "belowBaseLevel(first:5)"
                    }
                  ]
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getIssueTypeProps_initialOptionsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraJqlBuilder",
            "kind": "LinkedField",
            "name": "jqlBuilder",
            "plural": false,
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "JiraJqlIssueTypes",
                "kind": "LinkedField",
                "name": "issueTypes",
                "plural": false,
                "selections": [
                  {
                    "args": (v3/*: any*/),
                    "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                    "kind": "LinkedField",
                    "name": "aboveBaseLevel",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": "aboveBaseLevel(first:2)"
                  },
                  {
                    "args": (v8/*: any*/),
                    "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                    "kind": "LinkedField",
                    "name": "baseLevel",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": "baseLevel(first:3)"
                  },
                  {
                    "args": (v9/*: any*/),
                    "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                    "kind": "LinkedField",
                    "name": "belowBaseLevel",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": "belowBaseLevel(first:5)"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "bacee27ce08e8cbeca32c8698c834298f4e6536c5ce14e4f68ba78590d602fdb",
    "metadata": {},
    "name": "getIssueTypeProps_initialOptionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e9b9d86577b6b5b74847e060ec1e4725";

export default node;
